import Report from "./report.vue";

export default Report;



// WEBPACK FOOTER //
// ./src/components/_report/index.js